import ctl from "@netlify/classnames-template-literals";

export const getCardStyle = (isChecked: boolean, isDisabled: boolean) => {
  return ctl(`
    relative
    flex
    flex-row
    rounded-2xl
    font-base
    px-4
    py-3
    w-full
    transition-colors
    bg-neutral-800
    text-white
    hover:bg-neutral-700
    ${isChecked ? "bg-purple-900 hover:bg-purple-700" : ""}
    ${isDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
  `);
};

export const radioIndicator = ctl(`
  w-6
  h-6
  rounded-full
  border-2
  flex
  items-center
  justify-center
  transition-colors
`);
